import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { FcSearchInputModule } from '../../base/fc-search-input/fc-search-input.module';
import { FcCompanyInputComponent } from './fc-company-input.component';


@NgModule({
  declarations: [
    FcCompanyInputComponent
  ],
  imports: [
    CommonModule,
    FcSearchInputModule,
    TranslateModule
  ],
  exports: [
    FcCompanyInputComponent
  ]
})
export class FcCompanyInputModule {}
